/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

// word answer submission events
enum SubmissionEvent {
  Heard = 'heard',
  Correct = 'correct',
  ErrorIncorrect = 'errorIncorrect',
  ErrorWrongArticle = 'errorWrongArticle',
  ErrorMissingArticle = 'errorMissingArticle',
  ErrorCapitalization = 'errorCapitalization',
}

export default SubmissionEvent;
